import { Component, OnInit } from '@angular/core';
import { ApiCallsService } from '../../services/network/api-calls.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  isSpinnerVisible = false;
  
  constructor(private _apiCalls: ApiCallsService) { }
  
  ngOnInit(): void {
    this._apiCalls.loaderState.subscribe((data: any) => {
      if (data)
        this.isSpinnerVisible = true;
      else
        this.isSpinnerVisible = false;
    });
  }
}
